export const PRODUCT_NAME = 'HAi Report';
export const TITLE_PRODUCT_NAME = ` | ${PRODUCT_NAME}`;

export const FACEBOOK = 'Facebook';
export const GOOGLE = 'Google';
export const LINE = 'Line';
export const TABOOLA = 'Taboola';
export const HAIREPORT = 'Haireport';

export const FORMAT_DATE = 'yyyy/MM/dd';
export const DAY = 'DAY';
export const WEEK = 'WEEK';
export const MONTH = 'MONTH';
export const QUARTER = 'QUARTER';
export const YEAR = 'YEAR';
export const HOUR_LIST = ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'];

export const operators = [
  {
    type: "plus",
    operator: "+",
    display: "+"
  },
  {
    type: "subtraction",
    operator: "-",
    display: "-"
  },
  {
    type: "multiplication ",
    operator: "*",
    display: "×"
  },
  {
    type: "division ",
    operator: "/",
    display: "÷"
  },
  {
    type: "groupingBefore",
    operator: "(",
    display: "("
  },
  {
    type: "groupingAfter",
    operator: ")",
    display: ")"
  },
];

export const EMAIL_TEMPLATE_REACH = 'REACH_LINK_CLICK';
export const EMAIL_TEMPLATE_COVERSION_CAMPAIGN = 'CONVERSION_1';
export const EMAIL_TEMPLATE_COVERSION_METRICS = 'CONVERSION_2';

export const FIELDS_OVERVIEW = 'overviewFields';
export const FIELDS_CREATIVE = 'creativeFields';
export const FIELDS_TA = 'taFields';
export const LINE_FIELDS_OVERVIEW = 'line-overviewFields';
export const LINE_FIELDS_CREATIVE = 'line-taFields';
export const LINE_REMAINBUDGET = 'line-remainbudget';
export const SEARCH_OVERVIEW = 'SEARCH_OVERVIEW';
export const SEARCH_KEYWORD = 'SEARCH_KEYWORD';
export const PERFORMANCE_MAX = 'PERFORMANCE_MAX';
export const DEMAND_GEN = 'DEMAND_GEN';
export const VIDEO = 'VIDEO';
export const DISPLAY = 'DISPLAY';

export const AUTH_EDIT = 'permission.edit';
export const AUTH_EDIT_REPORT = 'weeklyreport.edit';
export const AUTH_BIND_AD_ACCOUNTS = 'permission.adaccount.bind';

export const ROLE_ADMIN = 'ADMIN';
export const ROLE_EDITOR = 'EDITOR';
export const ROLE_VIEWER = 'VIEWER';

// 
export const SESSION_CREATE_TIME = 'CreateAt';
export const DATA_NULL = '---';

export const EMAIL_REGEX = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z]+$/;

export const TABLE_ROW_HEIGHT = 48;
export const TABLE_ROW_HEIGHT_2 = 50;
export const TABLE_BASIC_ROW_NUM = 11;